import classNames from "classnames"
import "./index.less"

interface Option {
    label: string,
    value: string,
}

interface IProps {
    dataList: Option[];
    activeTab: string,
    setActiveTab: (e) => void
}

export default function RightPanelTab(props: IProps) {
    return (
        <div className="right-tab-main">
            {props.dataList.map(item => (
                <div
                    className={classNames({
                        "tab-item": true,
                        "tab-item-active": props.activeTab == item.value
                    })}
                    onClick={() => { props.setActiveTab(item.value) }}
                >
                    {item.label}
                </div>
            ))}
        </div>
    )
}